import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable } from 'react-bootstrap-table';

const Table = (props) => {
    const selectedIndex = props.selectedIndex;
    const optionsProps = {
        hideSizePerPage: true,
        noDataText: 'Brak wyników dla podanych parametrów',
        onPageChange: onPageChange,
        page: props.selectedPage,
        sizePerPage: 15
    };
    const selectRowProp = {
        clickToSelect: true,
        bgColor: '#b0e6b0',
        hideSelectColumn: true,
        mode: 'radio',
        onSelect: onRowSelect,
        selected: [selectedIndex]
    };

    function onPageChange(page) {
        props.pageChanged(page);
    }

    function onRowSelect(row) {
        props.selectedRowChanged(row);
    }

    return(
        <div
            className="col-xs-12 container-fluid">
            <BootstrapTable
                bordered={false}
                data = {props.data}
                hover 
                keyField = {props.keyField}
                options = {optionsProps}
                pagination
                selectRow = {selectRowProp}>
                {props.children}
            </BootstrapTable>
        </div> 
    );
};

Table.propTypes = {
    children: PropTypes.node,
    data: PropTypes.array,
    keyField :PropTypes.string,
    selectedIndex: PropTypes.number,
    selectedPage: PropTypes.number,
    selectedRowChanged: PropTypes.func,
    pageChanged: PropTypes.func
};

export default Table;


// WEBPACK FOOTER //
// ./src/components/base/Table/BootstrapTable.js